// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"loader_loader_wrapper__vMHf4","loader":"loader_loader__kCvI1","loaderAnimation":"loader_loaderAnimation__GPAer"};